import React from 'react';
import { testId } from '../../../../utils/testIds';
import CKTextEditor from '../../../CKTextEditor';
import './styles.scss';

function RichTextField({ value, onChange, disabled, config }) {
  return (
    <div
      data-test={testId('field', config?.fieldKey, 'editor')}
      className={`field-engine-rich-text-wrapper${disabled ? ' disabled' : ''}`}
    >
      <CKTextEditor
        editorData={value ?? ''}
        disableResize={false}
        onChange={onChange}
        readOnly={disabled}
      />
    </div>
  );
}

export default RichTextField;
